function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 32.867,
  y1: 2.923,
  x2: 32.867,
  y2: 23.643
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M32.736,124.31   c-17.57-9.304-30.059-33-30.059-60.764c0-27.82,12.539-51.558,30.167-60.821c17.627,9.264,30.213,33.001,30.213,60.821   c0,27.764-12.486,51.46-30.059,60.764H32.736z"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "32.886,23.765 22.899,33.251    16.908,63.46  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "2.678,63.46 10.417,45.235    12.913,22.517 32.886,12.28 26.395,6.787  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "16.908,63.46 10.417,45.235    22.899,33.251 32.886,12.28  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 10.667,
  y1: 45.484,
  x2: 5.174,
  y2: 43.488
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "32.821,23.765 42.809,33.251    48.799,63.46  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "63.027,63.46 55.29,45.235    52.793,22.517 32.821,12.28 39.312,6.787  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "48.799,63.46 55.29,45.235    42.809,33.251 32.821,12.28  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 55.04,
  y1: 45.484,
  x2: 60.532,
  y2: 43.488
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "32.886,103.191 22.899,93.706    16.908,63.496  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "2.678,63.496 10.417,81.721    12.913,104.439 25.39,107.868 26.395,120.168  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "16.908,63.496 10.417,81.721    22.899,93.706 25.39,107.868  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 10.667,
  y1: 81.472,
  x2: 5.174,
  y2: 83.469
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "32.821,103.191 42.809,93.706    48.799,63.496  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "63.027,63.496 55.29,81.721    52.793,104.439 40.296,107.868 39.312,120.168  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "48.799,63.496 55.29,81.721    42.809,93.706 40.296,107.868  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 55.04,
  y1: 81.472,
  x2: 60.532,
  y2: 83.469
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "32.867,103.143 25.572,107.721    32.867,124.316 40.449,107.721  "
}));

const SvgMarquise = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  x: "0px",
  y: "0px",
  width: "66px",
  height: "127.333px",
  viewBox: "0 0 66 127.333",
  enableBackground: "new 0 0 66 127.333",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarquise, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marquise.58971b4a.svg";
export { ForwardRef as ReactComponent };